import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_REFRESH_CW: GlameraIconDefinition = {
  name: 'refresh-cw',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-refresh-cw-part glm-refresh-cw-part-1" d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
    <path class="glm-refresh-cw-part glm-refresh-cw-part-2" d="M21 3v5h-5"></path>
    <path class="glm-refresh-cw-part glm-refresh-cw-part-3" d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
    <path class="glm-refresh-cw-part glm-refresh-cw-part-4" d="M8 16H3v5"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-refresh-cw-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './refresh-cw.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class RefreshCwIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_REFRESH_CW;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
